(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["close-friends-cart"] && !Shopify.designMode) return;
  try {
    class CloseFriendsCart extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.instagramInput = this.querySelector('[data-close-friends-instagram]');
      this.instagramAttribute = this.querySelector('[data-close-friends-instagram-attribute]');
      this.consentAttribute = this.querySelector('[data-close-friends-consent-attribute]');
      this.status = this.querySelector('[data-close-friends-status]');

      this.instagramInput.addEventListener('input', () => {
        this.sync();
        window.clearTimeout(this.saveTimer);
        this.saveTimer = window.setTimeout(() => this.save(), 600);
      });

      this.instagramInput.addEventListener('blur', () => this.save());

      this.sync();
    }

    normalizeUsername(value) {
      return value
        .trim()
        .replace(/^https?:\/\/(www\.)?instagram\.com\//i, '')
        .replace(/^@/, '')
        .replace(/\/.*$/, '')
        .replace(/[^a-zA-Z0-9._]/g, '')
        .slice(0, 30);
    }

    sync() {
      const username = this.normalizeUsername(this.instagramInput.value);
      const complete = username.length > 0;

      this.instagramAttribute.value = complete ? '@' + username : '';
      this.consentAttribute.value = complete ? 'Tak' : '';
    }

    async save() {
      this.sync();

      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            attributes: {
              'CLOSE FRIENDS - Instagram': this.instagramAttribute.value,
              'CLOSE FRIENDS - zgoda': this.consentAttribute.value
            }
          })
        });

        if (!response.ok) throw new Error('Cart update failed');

        this.status.textContent = this.consentAttribute.value ? 'Zapisano zgłoszenie do CLOSE FRIENDS.' : '';
      } catch (error) {
        this.status.textContent = 'Nie udało się zapisać. Spróbuj ponownie.';
      }
    }
  }

  if (!customElements.get('close-friends-cart')) {
    customElements.define('close-friends-cart', CloseFriendsCart);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["countdown-banner"] && !Shopify.designMode) return;
  try {
    class SaleCountdown extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;

      this.dataset.initialized = 'true';
      this.timeElement = this.querySelector('[data-countdown-time]');
      this.endAt = Date.parse(this.dataset.endAt);

      if (!this.timeElement || Number.isNaN(this.endAt)) return;

      this.update();
    }

    disconnectedCallback() {
      window.clearTimeout(this.timer);
    }

    pad(value) {
      return String(value).padStart(2, '0');
    }

    update() {
      const remaining = this.endAt - Date.now();

      if (remaining <= 0) {
        this.hidden = true;
        window.clearTimeout(this.timer);
        return;
      }

      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.timeElement.textContent = `${this.pad(days)}D ${this.pad(hours)}H ${this.pad(minutes)}M ${this.pad(seconds)}S`;
      this.hidden = false;

      window.clearTimeout(this.timer);
      this.timer = window.setTimeout(() => this.update(), 1000 - (Date.now() % 1000));
    }
  }

  if (!customElements.get('sale-countdown')) {
    customElements.define('sale-countdown', SaleCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
